import React from 'react';

const TaskItemStatic = ({word}) => {
  return (
    <span
      className="border border-dark bg-light user-select-none rounded d-flex flex-column px-75 justify-content-center text-center mb-1"
      style={{minWidth: '4rem', minHeight: '34px', marginRight: '0.17rem'}}
    >
      {word}
    </span>
  );
};

export default TaskItemStatic;
